<script>
// "Für mich" tool button (icon + small caption), matching the Favoriten/History
// tool-button style. Used across the exhibitor, community, speaker and talk navbars.
export default {
  props: {
    active: { type: Boolean, default: false },
  },
}
</script>

<template>
  <button class="btn btn-sm navbar-btn me-1 mb-1 c-tool-btn" :class="active ? 'text-primary' : ''"
   title="Für mich – passend zu meinen Interessen" @click.prevent="$emit('click')">
    <i class="fas fa-magic"></i>
    <span class="c-tool-btn-label">Für mich</span>
  </button>
</template>

<style scoped>
.c-tool-btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}
.c-tool-btn-label {
  font-size: 0.65rem;
  margin-top: 2px;
}
</style>
